import React from "react";
import { Link } from "react-router-dom";
import { FaChevronRight } from "react-icons/fa";
import { Translate } from "react-redux-i18n";
import ProductCard, { getKindCommerceLabel } from "./ProductCard";
import "./styles/HomeAdCarousel.css";
import "./styles/HomeFeedSkeleton.css";

function Shimmer({ className }) {
  return <div className={`home-skeleton-shimmer ${className}`} aria-hidden="true" />;
}

export function HomeAdCarouselSkeleton({ count = 4 }) {
  return (
    <section
      className="home-ad-section home-ad-section--skeleton"
      aria-busy="true"
      aria-label="Loading ads"
    >
      <header className="home-ad-section__header">
        <div className="home-ad-section__titles">
          <Shimmer className="home-skeleton-line home-skeleton-line--title" />
          <Shimmer className="home-skeleton-line home-skeleton-line--subtitle" />
        </div>
      </header>
      <div className="home-ad-carousel">
        {Array.from({ length: count }, (_, index) => (
          <article key={index} className="home-ad-skeleton-card">
            <Shimmer className="home-ad-skeleton-card__media" />
            <div className="home-ad-skeleton-card__body">
              <Shimmer className="home-skeleton-line home-skeleton-line--md" />
              <Shimmer className="home-skeleton-line home-skeleton-line--sm" />
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

function HomeAdCarousel({
  title,
  subtitle,
  links = [],
  adList = [],
  loading = false,
  onAdClick,
  maxItems = 12,
  seeMoreTo = "",
  seeMoreLabel,
}) {
  if (loading) {
    return <HomeAdCarouselSkeleton />;
  }

  const items = adList.slice(0, maxItems);
  const seeMoreHref = seeMoreTo || links[0]?.to || "";

  if (items.length === 0) {
    return null;
  }

  return (
    <section className="home-ad-section">
      <header className="home-ad-section__header">
        <div className="home-ad-section__titles">
          <h2 className="home-ad-section__title">{title}</h2>
          {subtitle && <p className="home-ad-section__subtitle">{subtitle}</p>}
        </div>
        {links.length > 0 && (
          <div className="home-ad-section__links">
            {links.map((link, index) => (
              <React.Fragment key={link.to}>
                {index > 0 && <span className="home-ad-section__link">·</span>}
                <Link to={link.to} className="home-ad-section__link">
                  {link.label}
                </Link>
              </React.Fragment>
            ))}
          </div>
        )}
      </header>

      <div className="home-ad-carousel">
        {items.map((ad) => (
          <ProductCard
            key={ad.Id}
            item={ad}
            kindCommerce={getKindCommerceLabel(ad.KindCommerceId)}
            onClick={() => onAdClick && onAdClick(ad)}
            columnClass="home-ad-carousel__item"
          />
        ))}
        {seeMoreHref && (
          <Link
            to={seeMoreHref}
            className="home-ad-carousel__item home-ad-see-more"
          >
            <div className="home-ad-see-more__inner">
              <span className="home-ad-see-more__label">
                {seeMoreLabel || <Translate value="see_more" />}
              </span>
              <FaChevronRight className="home-ad-see-more__icon" aria-hidden="true" />
            </div>
          </Link>
        )}
      </div>
    </section>
  );
}

export default HomeAdCarousel;
